import ItemsCollection, { Item } from './ItemsCollection';

import Axios from 'axios';
import Module from './Module';
import axiosInstance from '@/helpers/axios';
import stores from '@/stores/index';
import {generateLog} from '@/helpers/functions';
import {showToaster} from "@/components/DashboardComposer/helpers";

const CancelToken: any = Axios.CancelToken;
let cancel: any;

export class TvModuleItem extends Item implements IChannel {
  name!: string;
  description!: string;
  shortDescription!: string;
  timeShiftChannelName!: string;
  channelNumber!: number;
  imageId!: number;
  isAdult!: boolean;
  timeShift!: boolean;
  timeShiftDays!: number;
  epg!: boolean;
  recording!: boolean;
  type!: ChannelType;
  active!: boolean;
  categories!: ICategories[];
  sources!: ISource[];
}

export class TvItemsCollection extends ItemsCollection<TvModuleItem> {
  model() {
    return TvModuleItem;
  }

  url(): string {
    return this.module.url();
  }
}

export default class TvModule extends Module<TvItemsCollection> {

  routeName = 'tv';

  Collection() {
    return TvItemsCollection;
  }

  url() {
    return `/tv/${this.id}`;
  }

  urlChannel() {
    return `${this.url()}/channels`;
  }

  urlCategory() {
    return `${this.url()}/categories`;
  }

  updateItem(id: any, data: any) {
    return axiosInstance.patch(`${  this.urlChannel()}/${id}`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  updateCategory(id: any, category: ICategories) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}/`, category)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }
  getSubItems(id: number, search: string) {
    return axiosInstance.get(`${this.urlCategory()}/${id}/content?search=${search}`)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  sortCategories(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  sortChannels(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlChannel()}/${id}/resort`, {channelNumber: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteCategory(id: number) {
    return axiosInstance.delete(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItem(id: number) {
    return axiosInstance.delete(`${this.urlChannel()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.urlChannel()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  editExistingTimeshifte(id: number, timeshift: any) {
    return axiosInstance.put(`${this.urlChannel()}/${id}/timeshifts/${timeshift.id}`, timeshift)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteTimeshift(channelId: number, timeshiftId: number) {
    return axiosInstance.delete(`${this.urlChannel()}/${channelId}/timeshifts/${timeshiftId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewTimeshift(id: number, timeshift: any) {
    return axiosInstance.post(`${this.urlChannel()}/${id}/timeshifts`, timeshift)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  attachEPG(id: number, name: string) {
    return axiosInstance.post(`${this.urlChannel()}/${id}/epg/attach`, {channel: name})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  detachEPG(id: number, index: number) {
    return axiosInstance.delete(`${this.urlChannel()}/${id}/epg/detach/${index}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  editExistingSource(id: number, source: any) {
    return axiosInstance.put(`${this.urlChannel()}/${id}/sources/${source.id}`, source)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  saveCategories(id: number, tags: ICategories[]) {
    return axiosInstance.post(`${this.urlCategory()}/${id}/categories`, tags)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getCategories(id: number) {
    return axiosInstance.get(`${this.urlChannel()}/${id}/unattached`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getAutocompleteCategories(query: string, source: any) {
    return axiosInstance.get(`${this.urlCategory()}?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewSource(id: number, sources: any) {
    return axiosInstance.post(`${this.urlChannel()}/${id}/sources`, sources)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
        showToaster('danger', 'Error', e.response.data.error.message);
      });
  }

  getSourceTypes() {
    return axiosInstance.get(`${this.urlChannel()}/devices/types`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getSelectedChannel(id: number) {
    return axiosInstance.get(`${this.urlChannel()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getSelectedChannelSources(id: number) {
    return axiosInstance.get(`${this.urlChannel()}/${id}/sources`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  searchSelectedChannelSources(id: number, query: string, source: any) {
    return axiosInstance.get(`${this.urlChannel()}/${id}/sources?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteSource(channelID: number, sourceID: number) {
    return axiosInstance.delete(`${this.urlChannel()}/${channelID}/sources/${sourceID}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getUnattachedChannelsForCategory(id: number) {
    return axiosInstance.get(`${this.urlCategory()}/${id}/unattached`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  searchTvChannelCategory(id: number, input: string) {
    return axiosInstance.get(`${this.urlCategory()}/${id}?query=${input}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  saveTVModule(newModule: IModule, id: number) {
    return axiosInstance.put(`${this.url}/${id}`, newModule)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  editSelectedChannel(channel: IChannel) {
    return axiosInstance.put(`${this.urlChannel()}/${channel.id}`, channel)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  fetchData(index: number | null, search: string | null, perpage: number | null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (search) {
      return axiosInstance.get(`${this.urlChannel()}?search=${search}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
          .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'TvModule',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.urlChannel()}?page=${index}&perpage=${perpage}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
          .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'TvModule',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  fetchCategoryData(search: string | null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (search) {
      return axiosInstance.get(`${this.urlCategory()}?search=${search}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
          .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'TvModule',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.urlCategory()}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
          .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'TvModule',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  getAllModuleElements() {
    return axiosInstance.get(`${this.urlChannel()}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  search(input: string, source: any) {
    return axiosInstance.get(`${this.urlChannel()}?query=${input}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewItem(newChannel: IChannel) {
    return axiosInstance.post(`${this.urlChannel()}`, newChannel)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewCategory(newCategory: ICategories) {
    return axiosInstance.post(`${this.urlCategory()}`, {category: newCategory})
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getAllCategories(search: string | null = null) {
    if (cancel !== undefined) {
      cancel();
    }
    const searchString = (Boolean(search)) ? `search=${search}` : '';
    return axiosInstance.get(`${this.urlCategory()}?${searchString}`, {
      cancelToken: new CancelToken(function executor(c: any) {cancel = c; }),
    }).then((response) => response.data).catch((e) => {
      const log: any = {
        route: 'TvModule',
        message: e,
      };
      generateLog(log);
    });
  }

  searchCategory(input: string, source: any) {
    return axiosInstance.get(`${this.urlCategory()}?query=${input}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getSpecificCategory(id: number) {
    return axiosInstance.get(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  editCategory(category: ICategories) {
    return axiosInstance.put(`${this.urlCategory()}/${category.id}`, category)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  addChannelToCategory(category: ICategories, ids: number[]) {
    return axiosInstance.post(`${this.urlCategory()}/${category.id}/attach`, ids)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  detachCategoryfromChannel(channel: IChannel, n: any) {
    return axiosInstance.post(`${this.urlChannel()}/${channel.id}/detach`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  attachCategoryToChannel(channel: IChannel, n: any) {
    return axiosInstance.post(`${this.urlChannel()}/${channel.id}/attach`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }
  attachPackageToChannel(channel: IChannel, n: any) {
    return axiosInstance.post(`${this.urlChannel()}/${channel.id}/attachpackagetotv`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }
  detachPackage(channel: IChannel, n: any) {
    return axiosInstance.post(`${this.urlChannel()}/${channel.id}/detachpackagetotv`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  removeChannelfromCategory(category: ICategories, id: number) {
    return axiosInstance.post(`${this.urlCategory()}/${category.id}/detach`, id)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getTvChannelValidationRules() {
    return axiosInstance.get(`tvchannel/validation`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  getTvCategoryValidationRules() {
    return axiosInstance.get(`tvcategory/validation`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  import(data: any, tableName: string, id: any) {
    return axiosInstance.post(`import/${tableName}?type=module&module_id=${id}`, {data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  remoteImport(data: any) {
    return axiosInstance.post(`/tv/${this.id}/channels/remote-import`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }

  export(tableName: string, id: any) {
    return axiosInstance.get(`export/${tableName}?type=module&module_id=${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'TvModule',
          message: e,
        };
        generateLog(log);
      });
  }
}
